
    import {
        defineComponent, PropType, toRefs, SetupContext,
    } from 'vue';
    import { IReturnProductType } from '@ve/pages/hotel/types';
    import HotelCardAdditional from './HotelCardAdditional.vue';
    import TextIcon from '../hotelButtons/components/TextIcon.vue';
    import ButtonProduct from '../hotelButtons/ButtonProduct.vue';
    import ButtonPagination from '../hotelButtons/ButtonPagination.vue';
    import { IRoomCategories } from './types';
    import useInfoHotelCard from './use/useInfoHotelCard';
    import usePaginationHotelCard from './use/usePaginationHotelCard';
    import useHandlersHotelCard from './use/useHandlersHotelCard';
    import useLogicFilterHotelCard from './use/useLogicFilterHotelCard';

    export default defineComponent({
        components: {
            ButtonProduct,
            HotelCardAdditional,
            TextIcon,
            ButtonPagination,
        },
        props: {
            products: {
                type: Array as PropType<IReturnProductType[]>,
                default: [],
            },
            takenRoomCategories: {
                type: Array as PropType<IRoomCategories[]>,
                default: [],
            },
        },
        setup(props, context: SetupContext) {
            const { products, takenRoomCategories } = toRefs(props);

            const {
                getFirstProducts,
                firstProduct,
                groupedProductsByProductCriteria,
                currentTakenCategory,
            } = useLogicFilterHotelCard({ products, takenRoomCategories });

            const {
                getPhotos,
                touristText,
                dateText,
            } = useInfoHotelCard({ firstProduct });

            const {
                openDescriptionDialog,
                clickProductFirstHandler,
            } = useHandlersHotelCard({ products, currentTakenCategory }, context);

            const {
                paginationGroupedProducts,
                updateNumberCard,
                isNextProductsExists,
                paginationText,
                resetNumberCard,
            } = usePaginationHotelCard(groupedProductsByProductCriteria, 3, 'варианта;вариантов;вариантов');

            return {
                updateNumberCard,
                currentTakenCategory,
                paginationGroupedProducts,
                firstProduct,
                getPhotos,
                touristText,
                dateText,
                getFirstProducts,
                clickProductFirstHandler,
                openDescriptionDialog,
                groupedProductsByProductCriteria,
                isNextProductsExists,
                paginationText,
                resetNumberCard,
            };
        },
    });
